var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:`c-upload-btn ${_vm.btnClass ? _vm.btnClass: ''}`},[_c('input',{staticClass:"inp",attrs:{"type":"file","name":_vm.name},on:{"change":_vm.change}}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('img',{attrs:{"src":require(`@/assets/${_vm.img}`),"alt":"img"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }